import { useContent, useContentContext } from '@qbe/dfc-content';
import type { AddressFieldError, AddressFieldOverrides } from '@qbe/dfc-smart-ui';
import { getAddressLabel } from '../components/AddressSearch/addressHelpers';
import type { AddressType } from '../components/AddressSearch/addressTypes';

export const useAddressFieldOverrides = (type: AddressType): AddressFieldOverrides => {
  const { getTextContent } = useContent({ context: useContentContext() });

  const getIncludeUnitNumberText = getTextContent('addressAutocomplete.addressSearchIncludeUnitNumber');
  const getValidValueErrorMessage = getTextContent('addressAutocomplete.validValueErrorMessage');
  const getInvalidPostcodeErrorMessage = getTextContent('addressAutocomplete.invalidPostcodeErrorMessage');
  const getInvalidCharactersErrorMessage = getTextContent('addressAutocomplete.invalidCharactersErrorMessage');

  const textFieldErrorMessage = (error: AddressFieldError) =>
    error === 'invalid_characters' ? getInvalidCharactersErrorMessage : getValidValueErrorMessage;

  return {
    lookup: { label: getAddressLabel(type), helperText: getIncludeUnitNumberText },
    fields: {
      streetAddress1: { errorMessage: textFieldErrorMessage, maxLength: 225 },
      city: { errorMessage: textFieldErrorMessage, maxLength: 225 },
      state: { maxLength: 20 },
      postcode: { errorMessage: getInvalidPostcodeErrorMessage, placeholder: 'Postcode', maxLength: 15 },
    },
    hideRequiredIndicator: true,
  };
};
